import React, { useState, useContext } from "react";
import { BsArrowLeft, BsThreeDots } from "react-icons/bs";
import { CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
// @ts-ignore
import Image from "../../Assets/Images/Sat-images/arrow-sub-banner.webp";
import { useNavigate } from "react-router-dom";
// @ts-ignore
import UserContext from "../../utils/UserContext";

export interface SatSubBannerProps {
  title: string;
  subTitle?: string;
  about?: string;
  progressPercent?: number;
  chaptersCount: number;
  checkLesson?: string | boolean;
}

const SatSubBanner: React.FC<SatSubBannerProps> = (props) => {
  const navigate = useNavigate();
  const [checkClampLines, setCheckClampLines] = useState<boolean>(true);
  const { setCheckSatNavbar } = useContext<any>(UserContext);
  
  const HandleArrow = () => {
    navigate(-1);
  };
  
  const HandleSatNavBarResp = () => {
    setCheckSatNavbar(true);
  };
  
  return (
    <>
      <div className="subbanner-container">
        <div className="sub-banner-first-section">
          <div className="sub-banner-heading-icon-panel">
            <div className="sub-banner-icon-arrow" onClick={HandleArrow}>
              <BsArrowLeft size="23px" />
            </div>
            <div className="sub-banner-title">
              <p>
                <span className="sub-banner-title-span">
                </span>
              </p>
            </div>
          </div>
          <div className="Icon-panel-st">
            {window.innerWidth < 1024 ? (
              <div
                className="icon-st"
                onClick={() => {
                  HandleSatNavBarResp();
                }}
              >
                <BsThreeDots size="20" />
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
        <div className="sub-banner-second-section">
          <div className="second-section-left">
            <div>
              <h3 className="heading-sub-banner">
                {" "}
                {props.subTitle ? props.subTitle : props.title}
              </h3>
              {window.innerWidth < 1250 ? (
                <>
                  <p
                    className={
                      checkClampLines
                        ? "no-line-clamp"
                        : "set-margin-bottom-see-more"
                    }
                  >
                    {props?.about}
                  </p>
                  <span className="see-more-button">
                    {checkClampLines ? (
                      <p
                        onClick={() => {
                          setCheckClampLines(false);
                        }}
                      >
                        See more...
                      </p>
                    ) : (
                      <p
                        onClick={() => {
                          setCheckClampLines(true);
                        }}
                      >
                        see less
                      </p>
                    )}
                  </span>
                </>
              ) : (
                <p className="st-font">
                  {props?.about}
                </p>
              )}
            </div>
          </div>
          <div className="second-section-right">
            <div className="second-section-image">
              <img
                src={Image}
                className="arrow-image"
                alt="Arrow"
              />
            </div>
            <div className="sub-banner-Graph">
              <CircularProgressbar
                className="sub-progrees-bar"
                value={props.progressPercent ? props.progressPercent : 0}
                text={`${props.progressPercent ? props.progressPercent : 0}%`}
                styles={{ path: { stroke: "yellow" } }}
              />
            </div>
            <div className="second-section-progress">Progress</div>
          </div>
        </div>
        <div className="sub-banner-third-section">
          <div className="sub-banner-main-title">{props.title}</div>
          <div className="lesson-section">{`${props.chaptersCount} ${
            props?.checkLesson ? "Topics" : "Chapters"
          }`}</div>
        </div>
      </div>
    </>
  );
};
export default React.memo(SatSubBanner);
